import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import PanelContext from '../../sidebar/panel/panelContext';
import ArticleActions from '../../articleActions/articleActions';
import SavePdfAnchor from '../../articleActions/actionTypes/savePdfAnchor';
import PreviewButton from '../../articleActions/actionTypes/previewButton';
import ViewPdfAnchor from '../../articleActions/actionTypes/viewPdfAnchor';
import { PiiArticleEventsPropTypes } from '../../../utils/trackers/createArticleEvents';

export default function PiiArticleListItemActions({
  pii, pdfPath, openPreview, viewPdfEventData, savePdfEventData, onComponentClick,
}) {
  const { getId, didOpenPanel } = useContext(PanelContext);
  const idSuffix = getId();
  const previewButtonId = `preview-button-pii-${pii}-${idSuffix}`;
  const viewPdfAnchorId = `view-button-pii-${pii}-${idSuffix}`;

  return (
    <ArticleActions>
      <PreviewButton
        id={previewButtonId}
        onClick={openPreview}
        hasHighlight={didOpenPanel(previewButtonId)}
      />
      <ViewPdfAnchor
        id={viewPdfAnchorId}
        pii={pii}
        viewPdfEventData={viewPdfEventData}
        onClick={onComponentClick}
      />
      {pdfPath && (
        <SavePdfAnchor
          pdfPath={pdfPath}
          savePdfEventData={savePdfEventData}
          onClick={onComponentClick}
        />
      )}
    </ArticleActions>
  );
}

PiiArticleListItemActions.propTypes = {
  viewPdfEventData: PiiArticleEventsPropTypes.viewPdf,
  savePdfEventData: PiiArticleEventsPropTypes.savePdf,
  pii: PropTypes.string.isRequired,
  pdfPath: PropTypes.string,
  openPreview: PropTypes.func.isRequired,
  onComponentClick: PropTypes.func,
};

PiiArticleListItemActions.defaultProps = {
  viewPdfEventData: undefined,
  savePdfEventData: undefined,
  pdfPath: undefined,
  onComponentClick: undefined,
};
